import { render } from "./modal-register-form.vue?vue&type=template&id=664cdd02"
import script from "./modal-register-form.vue?vue&type=script&lang=js"
export * from "./modal-register-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__